import * as z from "zod";

const messages = {
  requiredField: "Campo obrigatório",
  minCharacters: (num) => `Mínimo de ${num} caracteres`,
};

// Formulário enxuto (D10 da parte 2, 03/09/2026): Nome, Tipo e Quantidade saíram
// do formulário de contrapartida — sobrou a Descrição (Status e Patrocinador são
// selects controlados, validados no submit; o backend valida a lista fechada de
// status em @/config/counterpartStatuses).
const CounterpartValidator = {
  description: z
    .string({ message: messages.requiredField })
    .min(2, { message: messages.minCharacters(2) }),
};

export default CounterpartValidator;
